import React, { useState } from 'react';

const ContactModal = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        businessName: '',
        phone: '',
        email: '',
        city: '',
        message: ''
    });

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        // Here we would handle the form submission
        console.log('Form data:', formData);
        alert('¡Gracias por tu interés! Nos pondremos en contacto contigo pronto.');
        onClose();
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4 overflow-y-auto bg-slate-900/40 backdrop-blur-sm animate-fade-in">
            <div className="bg-white w-full max-w-xl rounded-[2.5rem] shadow-2xl relative overflow-hidden animate-slide-up">
                {/* Background Brand Watermark */}
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden opacity-[0.08]">
                    <img
                        src="/EA-logo-esteticas.png"
                        alt=""
                        className="w-[150%] h-[150%] object-contain transform -translate-x-[2%]"
                    />
                </div>

                {/* Decorative background blobs */}
                <div className="absolute top-0 right-0 w-64 h-64 bg-rose-100/40 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl pointer-events-none" />
                <div className="absolute bottom-0 left-0 w-64 h-64 bg-violet-100/40 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl pointer-events-none" />

                <div className="relative p-8 md:p-12">
                    <button
                        onClick={onClose}
                        className="absolute top-6 right-8 text-slate-400 hover:text-slate-600 transition-colors"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>

                    <div className="flex flex-col items-center text-center mb-8">
                        <img src="/EA-logo-esteticas.png" alt="Logo" className="w-16 h-16 mb-4" />
                        <h2 className="text-3xl font-bold text-slate-900 mb-2">Suma tu Centro</h2>
                        <p className="text-rose-600 font-bold uppercase tracking-widest text-xs mb-4">Potenciamos tu visibilidad digital</p>
                        <p className="text-slate-500 max-w-sm leading-relaxed">
                            Únete al ecosistema más importante de estética en Argentina y conecta con miles de pacientes que buscan tus servicios.
                        </p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-1">
                                <label className="text-[10px] font-bold text-slate-600 uppercase tracking-widest ml-1">Tu Nombre</label>
                                <input
                                    required
                                    type="text"
                                    placeholder="Ej: Laura García"
                                    className="w-full bg-slate-50 border-none rounded-xl p-3 focus:ring-2 focus:ring-rose-200 transition-all text-slate-900 font-bold placeholder:text-slate-400"
                                    value={formData.name}
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                />
                            </div>
                            <div className="space-y-1">
                                <label className="text-[10px] font-bold text-slate-600 uppercase tracking-widest ml-1">Nombre del Centro</label>
                                <input
                                    required
                                    type="text"
                                    placeholder="Ej: Estética Wellness"
                                    className="w-full bg-slate-50 border-none rounded-xl p-3 focus:ring-2 focus:ring-rose-200 transition-all text-slate-900 font-bold placeholder:text-slate-400"
                                    value={formData.businessName}
                                    onChange={(e) => setFormData({ ...formData, businessName: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-1">
                                <label className="text-[10px] font-bold text-slate-600 uppercase tracking-widest ml-1">WhatsApp de Contacto</label>
                                <input
                                    required
                                    type="tel"
                                    placeholder="Ej: +54 9 11 ..."
                                    className="w-full bg-slate-50 border-none rounded-xl p-3 focus:ring-2 focus:ring-rose-200 transition-all text-slate-900 font-bold placeholder:text-slate-400"
                                    value={formData.phone}
                                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                />
                            </div>
                            <div className="space-y-1">
                                <label className="text-[10px] font-bold text-slate-600 uppercase tracking-widest ml-1">Correo Electrónico</label>
                                <input
                                    required
                                    type="email"
                                    placeholder="contacto@estetica.com"
                                    className="w-full bg-slate-50 border-none rounded-xl p-3 focus:ring-2 focus:ring-rose-200 transition-all text-slate-900 font-bold placeholder:text-slate-400"
                                    value={formData.email}
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="space-y-1">
                            <label className="text-[10px] font-bold text-slate-600 uppercase tracking-widest ml-1">Ciudad / Provincia</label>
                            <input
                                required
                                type="text"
                                placeholder="Ej: Rosario, Santa Fe"
                                className="w-full bg-slate-50 border-none rounded-xl p-3 focus:ring-2 focus:ring-rose-200 transition-all text-slate-900 font-bold placeholder:text-slate-400"
                                value={formData.city}
                                onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-gradient-to-r from-rose-500 to-violet-600 text-white font-bold py-4 rounded-xl shadow-lg shadow-rose-200 hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 mt-6"
                        >
                            Solicitar Registro Ahora
                        </button>
                    </form>

                    <p className="text-[10px] text-center text-slate-400 mt-6 leading-relaxed">
                        Al enviar, aceptas que procesemos tus datos para contactarte sobre nuestro directorio.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ContactModal;
